import React, { useEffect, useRef, useState } from "react";
import "./updateDeleteModal.css";
import { useDispatch, useSelector } from "react-redux";
import { FUNC_COMPONENT_ACTION_TYPE } from "../../../redux/actions-type";
import { ReactComponent as MoreIcon } from "../../../assets/icons/more.svg";
import {
  downloadContractAction,
  downloadStudentPaymentsAction,
} from "../../../redux/actions/studentsActions";
import { MdOutlineFileDownload } from "react-icons/md";
import { useNavigate } from "react-router-dom";

const UpdateDeleteModal = ({
  updateItem = () => {},
  deleteItem = () => {},
  data,
  dataType = "",
  openConfirmModal,
  profil,
  setShowDeleteModal,
  modelName,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { funcComp } = useSelector((state) => state.funcComponent);
  const { user } = useSelector((state) => state.user);
  const [updateBtn, setUpdateBtn] = useState(false);
  const [contractBtn, setContractBtn] = useState(false);
  const [paymentsTableBtn, setPaymentsTableBtn] = useState(false);
  const [paymentsBtn, setPaymentsBtn] = useState(false);
  const [deleteBtn, setDeleteBtn] = useState(false);
  const documentId =
    modelName === "student" || modelName === "group"
      ? data?._id
      : modelName === "tuition-fee"
      ? data?.studentId
      : null;
  const groupId = modelName === "tuition-fee" ? data.group._id : "";
  const [changesBtn, setChangesBtn] = useState(false);

  const handleShowDeleteModal = () => {
    setShowDeleteModal(true);
  };

  const modalRef = useRef(null);

  const handleClickOutside = () => {
    dispatch({
      type: FUNC_COMPONENT_ACTION_TYPE.GET_FUNC_COMP,
      payload: false,
    });
  };

  const handleToggleModal = (e) => {
    e.stopPropagation();
    if (funcComp === data._id) {
      dispatch({
        type: FUNC_COMPONENT_ACTION_TYPE.GET_FUNC_COMP,
        payload: false,
      });
    } else {
      dispatch({
        type: FUNC_COMPONENT_ACTION_TYPE.GET_FUNC_COMP,
        payload: data._id,
      });
    }
  };

  const downloadContract = () => {
    for (let i = 0; i < data?.groups?.length || 0; i++) {
      downloadContractAction({
        fullName: data?.fullName,
        studentId: data?._id,
        groupId: data?.groups[i]?.group?._id,
      });
    }
  };

  const downloadStudentPayments = () => {
    if (profil === "students") {
      downloadStudentPaymentsAction({
        fullName: data?.fullName,
        studentId: data?._id,
        groupId: data?.groups[0]?.group?._id,
      });
    } else if (profil === "tuitionFee") {
      downloadStudentPaymentsAction({
        fullName: data?.fullName,
        studentId: data?.studentId,
        groupId: data?.group?._id,
      });
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClickOutside]);

  useEffect(() => {
    if (user?.role === "super-admin") {
      setUpdateBtn(true);
      setDeleteBtn(true);
      setChangesBtn(true);
      if (profil === "tuitionFee") {
        setPaymentsBtn(true);
        setPaymentsTableBtn(true);
      }

      if (profil === "students") {
        setContractBtn(true);
        setPaymentsTableBtn(true);
      }
    } else if (user?.role === "worker") {
      const power = user?.profiles?.find(
        (item) => item.profile === profil
      )?.power;
      setChangesBtn(true);

      if (power === "all") {
        setDeleteBtn(true);
      }

      if (profil === "students") {
        setContractBtn(true);
        setPaymentsTableBtn(true);
      }

      if (profil === "tuitionFee") {
        setPaymentsBtn(true);
        setPaymentsTableBtn(true);
      }

      if (power !== "only-show") {
        setUpdateBtn(true);
      }
    } else if (user?.role === "teacher") {
      if (profil === "lessonTable" && data?.topic?.name !== "Praktika") {
        setUpdateBtn(true);
      }
    } else if (user?.role === "mentor") {
      setUpdateBtn(true);
    } else if (user?.role === "student") {
      setUpdateBtn(true);
    }
  }, []);

  return (
    <div className="func-component">
      <MoreIcon className="more-icon" onMouseDown={handleToggleModal} />
      <div
        className={`delete-update-modal  ${
          funcComp === data._id ? "active" : ""
        }`}
        ref={modalRef}
      >
        <>
          {dataType !== "feedback" && profil !== "tuitionFee" && updateBtn && (
            <h4 onClick={updateItem}>Yenilə</h4>
          )}

          {changesBtn && (
            <h4
              onClick={() =>
                navigate(
                  `/updates/${documentId}/${modelName}?groupId=${groupId}`
                )
              }
            >
              <div style={{ position: "relative" }}>
                <span>Yeniləmələr</span>
              </div>
            </h4>
          )}

          {paymentsBtn && (
            <h4 className="confirm" onClick={openConfirmModal}>
              Ödənişlər
            </h4>
          )}

          {deleteBtn &&
            profil !== "careers" &&
            profil !== "tuitionFee" &&
            profil !== "whereHeard" &&
            profil !== "diploma" && (
              <h4
                className={`delete-func ${
                  dataType === "branches" ? "only" : ""
                }`}
                onClick={handleShowDeleteModal}
              >
                Sil
              </h4>
            )}

          {contractBtn && (
            <h4
              className="confirm"
              onClick={downloadContract}
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <span>Müqavilə</span>
              <MdOutlineFileDownload style={{}} />
            </h4>
          )}
          {paymentsTableBtn && (
            <h4
              className="confirm"
              onClick={downloadStudentPayments}
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "10px",
                width: "200px",
              }}
            >
              <span>Ödəniş cədvəli</span>
              <MdOutlineFileDownload style={{}} />
            </h4>
          )}
        </>
      </div>
    </div>
  );
};

export default UpdateDeleteModal;
